import React from 'react';
import { MetricSlider } from './MetricSlider';

interface Metric {
  label: string;
  value: number;
  min: number;
  max: number;
  weight: string;
  unit?: string;
  isPercentage?: boolean;
  description?: string;
}

interface MetricCategoryProps {
  metrics: Metric[];
  onMetricChange: (label: string, value: number, weight: string) => void;
}

export const MetricCategory: React.FC<MetricCategoryProps> = ({
  metrics,
  onMetricChange,
}) => {
  return (
    <div className="space-y-6">
      {metrics.map((metric) => (
        <MetricSlider
          key={`${metric.label}-${metric.weight}`}
          label={metric.label}
          value={metric.value}
          onChange={(value) => onMetricChange(metric.label, value, metric.weight)}
          min={metric.min}
          max={metric.max}
          weight={metric.weight}
          unit={metric.unit}
          isPercentage={metric.isPercentage}
          description={metric.description}
        />
      ))}
    </div>
  );
};